import { forwardRef, useContext } from 'react';
import styles from './Link.module.scss.js';
import { UNSAFE_LinkContext } from './LinkContext.js';
import { useLinkSource } from './LinkProvider.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { UNSAFE_Icon } from '../icon/Icon.js';
import { MdOpenInNew, MdArrowForward } from '../node_modules/react-icons/md/index.js';
import classNames from 'clsx';

const actionIndicators = {
  MdArrowForward,
  MdOpenInNew
};
const Link = /*#__PURE__*/forwardRef(function Link(props, ref) {
  const {
    Link: ResolvedLink,
    linkProps,
    rest
  } = useLinkSource(props);
  const ctx = useContext(UNSAFE_LinkContext);
  const {
    className: callerClassName,
    tag,
    children,
    icon,
    actionIndicator,
    variant: callerVariant = 'default',
    linkStyle: callerLinkStyle = 'inline',
    size: callerSize = 'default',
    ...dataProps
  } = rest;
  const variant = ctx.variant ?? callerVariant;
  const linkStyle = ctx.linkStyle ?? callerLinkStyle;
  const size = ctx.size ?? callerSize;
  const className =
  // This is an internal variant that will provide no styles to
  // encapsulate other components more easily.
  variant === 'UNSAFE_unset' ? classNames('dsx-component', callerClassName) : classNames('dsx-component', styles.link, styles[`variant-${variant}`], styles[`link-style-${linkStyle}`], styles[`size-${size}`], callerClassName);
  return /*#__PURE__*/jsxs(ResolvedLink, {
    ...dataProps,
    ...linkProps,
    className: className,
    ref: ref,
    "data-dsx--link": tag,
    children: [icon && /*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: icon
    }), children, actionIndicator && /*#__PURE__*/jsx(UNSAFE_Icon, {
      icon: actionIndicators[actionIndicator]
    })]
  });
});

export { Link };
